import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Education from '../components/Work/Education';
import Skills from '../components/Work/Skills';
import Experience from '../components/Work/Experience';
import Projects from '../components/Work/Projects';
import Patents from '../components/Work/Patents';
import Innovations from '../components/Innovations';
import YouTube from '../components/YouTube';
import Blog from '../components/Blog';
import DynamicSections from '../components/DynamicSections';
import CollaborateSection from '../components/CollaborateSection';
import Footer from '../components/Footer';
import AIChatbot from '../components/AIChatbot';
import Testimonials from '../components/Testimonials.jsx';
import { usePortfolio } from '../context/PortfolioContext';

const Home = () => {
  const { portfolioData, loading, error } = usePortfolio();

  useEffect(() => {
      // Add smooth scrolling for anchor links
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - 80, // Adjust for navbar height
              behavior: 'smooth'
            });
          }
        });
      });
      
      return () => {
        // Clean up event listeners
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
          anchor.removeEventListener('click', function () {});
        });
      };
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-900">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mb-4"></div>
        <pre className="text-gray-400 text-xs">Loading: {JSON.stringify({ loading, error })}</pre>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-900">
        <div className="text-white text-center p-8">
          <h1 className="text-2xl font-bold mb-4">Portfolio Error</h1>
          <p className="text-gray-400 mb-4">{error}</p>
          <pre className="text-gray-400 text-xs">Error: {JSON.stringify(error)}</pre>
        </div>
      </div>
    );
  }

  if (!portfolioData) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-900">
        <div className="text-white text-center p-8">
          <h1 className="text-2xl font-bold mb-4">No Portfolio Data</h1>
          <pre className="text-gray-400 text-xs">portfolioData: {JSON.stringify(portfolioData)}</pre>
        </div>
      </div>
    );
  }

  const {
    profile = {},
    about = {},
    skills = [],
    experience = [],
    education = [],
    blog = [],
    youtube = [],
    projects = [],
    innovations = [],
    sections = [],
    collaborate = []
  } = portfolioData;

  return (
    <div className="min-h-screen bg-gray-900">
      <Helmet>
        <meta name="description" content="Dhiraj T H - AI Engineer, Full-Stack Developer, YouTuber, and Innovator. Explore my portfolio featuring AI projects, web applications, and mechanical innovations." />
        <meta name="keywords" content="Dhiraj TH, AI Engineer, Full-Stack Developer, YouTuber, Innovations, Portfolio" />
        <meta property="og:title" content="Dhiraj T H | AI Engineer, Freelancer, YouTuber, Innovator" />
        <meta property="og:description" content="Explore my portfolio featuring cutting-edge AI projects, web applications, and mechanical innovations." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dhirajth.com" />
        <meta property="og:image" content="https://dhirajth.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      
      <Navbar />
      <Hero />
      <About />
      
      <section id="work" className="py-20 bg-gray-900">
        <div className="container">
          <h2 className="section-title text-white mb-12">My Work</h2>
          <Education />
          <Skills />
          <Experience />
          <Projects />
          <Patents />
        </div>
      </section>
      
      <Innovations />
      <YouTube />
      <Blog />
      <DynamicSections />
      <CollaborateSection />
      <Footer />
      <AIChatbot />
    </div>
  );
};

export default Home; 